import React, { useState } from "react";
import { InertiaLink } from "@inertiajs/inertia-react";
import { ArrowRight } from "react-feather";
import { Subheader } from "@/Components/Subheader";
import classNames from "classnames";

export function BlockButton({
  children,
  href,
  className = "",
  bgcolor = "bg-primary",
  title,
  text,
}) {
  return (
    <InertiaLink
      href={href}
      className={classNames(
        "md:min-w-1/3 grow-1 flex w-full flex-row items-center justify-between px-4 py-5 text-white transition-colors duration-200",
        className,
        `${bgcolor}`,
      )}
    >
      <div className="flex flex-col">
        <Subheader className="font-light uppercase" margin="mt-0">
          {title}
        </Subheader>
        <span className="text-md font-bold">{text}</span>
      </div>
      <ArrowRight />
    </InertiaLink>
  );
}
